import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  loader: { marginRight: theme.spacing(2) },
}));

export default function Loading({ loading }: { loading: boolean }) {
  const classes = useStyles();

  return (
    <>
      {loading && (
        <div className={classes.loadingContainer}>
          <CircularProgress color="primary" className={classes.loader} />
          <Typography>One moment while we redirect you.</Typography>
        </div>
      )}
    </>
  );
}
